"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stateCodeList = exports.stateDescriptionList = exports.getStateCodes = exports.getStateDescriptionCodes = void 0;
const enums_1 = require("../enums");
/**
 * return state list of codes with their state description
 * ```ts
 * example return list of states in this format
 * { code: 'SC', description: 'South Carolina'}
 * ```
 * @returns cloned state list of codes with their state descriptions
 */
function getStateDescriptionCodes() {
    return JSON.parse(JSON.stringify(exports.stateDescriptionList));
}
exports.getStateDescriptionCodes = getStateDescriptionCodes;
/**
 * return state list of codes with their state code
 * ```ts
 * example return list of states in this format
 * { code: 'SC', description: 'SC'}
 * ```
 * @returns cloned state list of codes with their state descriptions
 */
function getStateCodes() {
    return JSON.parse(JSON.stringify(exports.stateCodeList));
}
exports.getStateCodes = getStateCodes;
/**
 * list of US states using code as a key and description as the US state description
 */
exports.stateDescriptionList = [
    { code: enums_1.USStateName.ALABAMA, description: 'Alabama' },
    { code: enums_1.USStateName.ALASKA, description: 'Alaska' },
    { code: enums_1.USStateName.ARIZONA, description: 'Arizona' },
    { code: enums_1.USStateName.ARKANSAS, description: 'Arkansas' },
    { code: enums_1.USStateName.CALIFORNIA, description: 'California' },
    { code: enums_1.USStateName.COLORADO, description: 'Colorado' },
    { code: enums_1.USStateName.CONNECTICUT, description: 'Connecticut' },
    { code: enums_1.USStateName.DELAWARE, description: 'Delaware' },
    { code: enums_1.USStateName.FLORIDA, description: 'Florida' },
    { code: enums_1.USStateName.GEORGIA, description: 'Georgia' },
    { code: enums_1.USStateName.HAWAII, description: 'Hawaii' },
    { code: enums_1.USStateName.IDAHO, description: 'Idaho' },
    { code: enums_1.USStateName.ILLINOIS, description: 'Illinois' },
    { code: enums_1.USStateName.INDIANA, description: 'Indiana' },
    { code: enums_1.USStateName.IOWA, description: 'Iowa' },
    { code: enums_1.USStateName.KANSAS, description: 'Kansas' },
    { code: enums_1.USStateName.KENTUCKY, description: 'Kentucky' },
    { code: enums_1.USStateName.LOUISIANA, description: 'Louisiana' },
    { code: enums_1.USStateName.MAINE, description: 'Maine' },
    { code: enums_1.USStateName.MARYLAND, description: 'Maryland' },
    { code: enums_1.USStateName.MASSACHUSETTS, description: 'Massachusetts' },
    { code: enums_1.USStateName.MICHIGAN, description: 'Michigan' },
    { code: enums_1.USStateName.MINNESOTA, description: 'Minnesota' },
    { code: enums_1.USStateName.MISSISSIPPI, description: 'Mississippi' },
    { code: enums_1.USStateName.MISSOURI, description: 'Missouri' },
    { code: enums_1.USStateName.MONTANA, description: 'Montana' },
    { code: enums_1.USStateName.NEBRASKA, description: 'Nebraska' },
    { code: enums_1.USStateName.NEVADA, description: 'Nevada' },
    { code: enums_1.USStateName.NEW_HAMPSHIRE, description: 'New Hampshire' },
    { code: enums_1.USStateName.NEW_JERSEY, description: 'New Jersey' },
    { code: enums_1.USStateName.NEW_MEXICO, description: 'New Mexico' },
    { code: enums_1.USStateName.NEW_YORK, description: 'New York' },
    { code: enums_1.USStateName.NORTH_CAROLINA, description: 'North Carolina' },
    { code: enums_1.USStateName.NORTH_DAKOTA, description: 'North Dakota' },
    { code: enums_1.USStateName.OHIO, description: 'Ohio' },
    { code: enums_1.USStateName.OKLAHOMA, description: 'Oklahoma' },
    { code: enums_1.USStateName.OREGON, description: 'Oregon' },
    { code: enums_1.USStateName.PENNSYLVANIA, description: 'Pennsylvania' },
    { code: enums_1.USStateName.RHODE_ISLAND, description: 'Rhode Island' },
    { code: enums_1.USStateName.SOUTH_CAROLINA, description: 'South Carolina' },
    { code: enums_1.USStateName.SOUTH_DAKOTA, description: 'South Dakota' },
    { code: enums_1.USStateName.TENNESSEE, description: 'Tennessee' },
    { code: enums_1.USStateName.TEXAS, description: 'Texas' },
    { code: enums_1.USStateName.UTAH, description: 'Utah' },
    { code: enums_1.USStateName.VERMONT, description: 'Vermont' },
    { code: enums_1.USStateName.VIRGINIA, description: 'Virginia' },
    { code: enums_1.USStateName.WASHINGTON, description: 'Washington' },
    { code: enums_1.USStateName.WEST_VIRGINIA, description: 'West Virginia' },
    { code: enums_1.USStateName.WISCONSIN, description: 'Wisconsin' },
    { code: enums_1.USStateName.WYOMING, description: 'Wyoming' }
];
/**
 * list of US states using code as a key and description as the US state code
 */
exports.stateCodeList = [
    { code: enums_1.USStateName.ALABAMA, description: enums_1.USStateName.ALABAMA },
    { code: enums_1.USStateName.ALASKA, description: enums_1.USStateName.ALASKA },
    { code: enums_1.USStateName.ARIZONA, description: enums_1.USStateName.ARIZONA },
    { code: enums_1.USStateName.ARKANSAS, description: enums_1.USStateName.ARKANSAS },
    { code: enums_1.USStateName.CALIFORNIA, description: enums_1.USStateName.CALIFORNIA },
    { code: enums_1.USStateName.COLORADO, description: enums_1.USStateName.COLORADO },
    { code: enums_1.USStateName.CONNECTICUT, description: enums_1.USStateName.CONNECTICUT },
    { code: enums_1.USStateName.DELAWARE, description: enums_1.USStateName.DELAWARE },
    { code: enums_1.USStateName.FLORIDA, description: enums_1.USStateName.FLORIDA },
    { code: enums_1.USStateName.GEORGIA, description: enums_1.USStateName.GEORGIA },
    { code: enums_1.USStateName.HAWAII, description: enums_1.USStateName.HAWAII },
    { code: enums_1.USStateName.IDAHO, description: enums_1.USStateName.IDAHO },
    { code: enums_1.USStateName.ILLINOIS, description: enums_1.USStateName.ILLINOIS },
    { code: enums_1.USStateName.INDIANA, description: enums_1.USStateName.INDIANA },
    { code: enums_1.USStateName.IOWA, description: enums_1.USStateName.IOWA },
    { code: enums_1.USStateName.KANSAS, description: enums_1.USStateName.KANSAS },
    { code: enums_1.USStateName.KENTUCKY, description: enums_1.USStateName.KENTUCKY },
    { code: enums_1.USStateName.LOUISIANA, description: enums_1.USStateName.LOUISIANA },
    { code: enums_1.USStateName.MAINE, description: enums_1.USStateName.MAINE },
    { code: enums_1.USStateName.MARYLAND, description: enums_1.USStateName.MARYLAND },
    { code: enums_1.USStateName.MASSACHUSETTS, description: enums_1.USStateName.MASSACHUSETTS },
    { code: enums_1.USStateName.MICHIGAN, description: enums_1.USStateName.MICHIGAN },
    { code: enums_1.USStateName.MINNESOTA, description: enums_1.USStateName.MINNESOTA },
    { code: enums_1.USStateName.MISSISSIPPI, description: enums_1.USStateName.MISSISSIPPI },
    { code: enums_1.USStateName.MISSOURI, description: enums_1.USStateName.MISSOURI },
    { code: enums_1.USStateName.MONTANA, description: enums_1.USStateName.MONTANA },
    { code: enums_1.USStateName.NEBRASKA, description: enums_1.USStateName.NEBRASKA },
    { code: enums_1.USStateName.NEVADA, description: enums_1.USStateName.NEVADA },
    { code: enums_1.USStateName.NEW_HAMPSHIRE, description: enums_1.USStateName.NEW_HAMPSHIRE },
    { code: enums_1.USStateName.NEW_JERSEY, description: enums_1.USStateName.NEW_JERSEY },
    { code: enums_1.USStateName.NEW_MEXICO, description: enums_1.USStateName.NEW_MEXICO },
    { code: enums_1.USStateName.NEW_YORK, description: enums_1.USStateName.NEW_YORK },
    { code: enums_1.USStateName.NORTH_CAROLINA, description: enums_1.USStateName.NORTH_CAROLINA },
    { code: enums_1.USStateName.NORTH_DAKOTA, description: enums_1.USStateName.NORTH_DAKOTA },
    { code: enums_1.USStateName.OHIO, description: enums_1.USStateName.OHIO },
    { code: enums_1.USStateName.OKLAHOMA, description: enums_1.USStateName.OKLAHOMA },
    { code: enums_1.USStateName.OREGON, description: enums_1.USStateName.OREGON },
    { code: enums_1.USStateName.PENNSYLVANIA, description: enums_1.USStateName.PENNSYLVANIA },
    { code: enums_1.USStateName.RHODE_ISLAND, description: enums_1.USStateName.RHODE_ISLAND },
    { code: enums_1.USStateName.SOUTH_CAROLINA, description: enums_1.USStateName.SOUTH_CAROLINA },
    { code: enums_1.USStateName.SOUTH_DAKOTA, description: enums_1.USStateName.SOUTH_DAKOTA },
    { code: enums_1.USStateName.TENNESSEE, description: enums_1.USStateName.TENNESSEE },
    { code: enums_1.USStateName.TEXAS, description: enums_1.USStateName.TEXAS },
    { code: enums_1.USStateName.UTAH, description: enums_1.USStateName.UTAH },
    { code: enums_1.USStateName.VERMONT, description: enums_1.USStateName.VERMONT },
    { code: enums_1.USStateName.VIRGINIA, description: enums_1.USStateName.VIRGINIA },
    { code: enums_1.USStateName.WASHINGTON, description: enums_1.USStateName.WASHINGTON },
    { code: enums_1.USStateName.WEST_VIRGINIA, description: enums_1.USStateName.WEST_VIRGINIA },
    { code: enums_1.USStateName.WISCONSIN, description: enums_1.USStateName.WISCONSIN },
    { code: enums_1.USStateName.WYOMING, description: enums_1.USStateName.WYOMING }
];
//# sourceMappingURL=state-codes.js.map